import * as React from 'react';
import { useState } from 'react';

import { Button, Modal } from '@components/common';
import { ButtonProps } from '@components/common/Button';

interface Props extends ButtonProps {
  modalTitle?: string;
  modalBody?: React.ReactNode;
  danger?: boolean;
  confirmText?: string;
  cancelText?: string;
  href?: string;
  modalSize?: 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
}

export const ConfirmingButton = ({
  modalTitle = 'Are you sure?',
  modalBody,
  danger,
  modalSize = 'md',
  confirmText = 'Continue',
  cancelText = 'Cancel',
  onClick,
  href,
  ...buttonProps
}: Props) => {
  const [open, setOpen] = useState(false);

  const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    setOpen(true);
  };

  const handleConfirm = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    setOpen(false);

    if (onClick) {
      onClick(e);
    } else if (href) {
      if (buttonProps.target === '_blank') {
        window.open(href, '_blank', 'noopener,noreferrer');
      } else {
        window.location.assign(href);
      }
    }
  };

  return (
    <>
      <Button {...buttonProps} onClick={handleClick}>
        {buttonProps.children}
      </Button>
      {open && (
        <Modal
          size={modalSize}
          title={modalTitle}
          icon={danger ? 'danger' : undefined}
          onClose={() => setOpen(false)}
          renderFooter={() => (
            <>
              <Button
                onClick={() => setOpen(false)}
                trackEvent='clicked_cancel_confirming_button'
                trackProps={{ page: modalTitle, text: cancelText }}
              >
                {cancelText}
              </Button>
              <Button
                danger={danger}
                primary={!danger}
                onClick={handleConfirm}
                trackEvent='clicked_confirm_confirming_button'
                trackProps={{ page: modalTitle, text: confirmText }}
              >
                {confirmText}
              </Button>
            </>
          )}
        >
          {modalBody}
        </Modal>
      )}
    </>
  );
};
